import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";

export class BambooSecretsFillingPot2 extends SlotGameType1_2
{

    //protected override freegameBonusFactory: FreegameBonusFactory2 = new BambooSecretsFillingPotFreegame2BonusFactory();
    protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();
    // public override TitleLoaded(resourceManager:ResourceManager)
    // {
    //     super.TitleLoaded(resourceManager);

    //     SetStyles(this.view.querySelector(".title"),
    //     {
    //         display:"flex",
    //         justifyContent:"center",
    //         margin:"26px",
    //     });
    //     this.titleSprite.Scale(1.5);
    // }
}